export class ForgotPasswordMessage {
  email: string
  
  constructor(email: string) {
    this.email = email
  }
}
  